export default "__VITE_ASSET__z6jIPvk1__"